import { UserSortField } from '@/core/graphql/graphql';
import { UsersFragment } from '@/core/graphql/graphql';
import { Column, ColumnAlignment, ColumnType, FilterConfig } from '@/shared/components/table/table.model';
import { extractProperty } from "@/utils/extract-property";

export const USER_COLUMNS: Column<UsersFragment>[] = [
  {
    columnId: "name",
    caption: "Name",
    fieldSelector: (user: UsersFragment) => extractProperty(user.name),
  },
  {
    columnId: "username",
    caption: "User Name",
    fieldSelector: (user: UsersFragment) => extractProperty(user.username),
    sortable: true,
  },
  {
    columnId: "email",
    caption: "Email",
    fieldSelector: (user: UsersFragment) => extractProperty(user.email),
  },
  {
    columnId: "createdAt",
    caption: "Registered",
    fieldSelector: (user: UsersFragment) => extractProperty(user.createdAt),
    sortable: true,
    type: ColumnType.Date,
  },
  {
    columnId: "isPremium",
    caption: "Premium",
    fieldSelector: (user: UsersFragment) => extractProperty(user.isPremium),
  },
  {
    columnId: "numberOfClusters",
    caption: "#Clusters",
    fieldSelector: (user: UsersFragment) => extractProperty(user.statistics.numberOfClusters),
    alignment: ColumnAlignment.Centered,
  },
  {
    columnId: "numberOfElements",
    caption: "#Elements",
    fieldSelector: (user: UsersFragment) => extractProperty(user.statistics.numberOfElements),
    alignment: ColumnAlignment.Centered,
  },
  {
    columnId: "numberOfConnections",
    caption: "#Connections",
    fieldSelector: (user: UsersFragment) => extractProperty(user.statistics.numberOfConnections),
    alignment: ColumnAlignment.Centered,
  },
  {
    columnId: "numberOfFollowers",
    caption: "#Followers",
    fieldSelector: (user: UsersFragment) => extractProperty(user.statistics.numberOfFollowers),
    alignment: ColumnAlignment.Centered,
  },
  {
    columnId: "numberOfFollowing",
    caption: "#Following",
    fieldSelector: (user: UsersFragment) => extractProperty(user.statistics.numberOfFollowing),
    alignment: ColumnAlignment.Centered,
  },
];

export const USER_FILTER_CONFIG: FilterConfig = {
  propertyName: 'Filter by premium',
  filterOptions: [
    'All',
    'Premium',
    'Non-premium',
  ],
};

export const USER_SORT_FIELD = (option: string): UserSortField => {
  switch (option) {
  case "username":
    return UserSortField.Username;
  case "createdAt":
    return UserSortField.CreatedAt;
  default:
    throw new Error('Unsupported sorting field');
  }
};
